export const SCREEN_TRANSITION = 500

export enum AnimationDuration {
  fast = 200,
  med = 400,
  slow = 800,
}


export const panelRadius = 36
export const panelPadding = 30
